import { render, staticRenderFns } from "./ReportTemplateDetailsModal.vue?vue&type=template&id=0ef71608&"
import script from "./ReportTemplateDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./ReportTemplateDetailsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports